import { render } from "./GeolocationButton.vue?vue&type=template&id=32e5f590&ts=true"
import script from "./GeolocationButton.vue?vue&type=script&lang=ts"
export * from "./GeolocationButton.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__